import React from 'react';

import { BlanketInsuranceCreateDetails } from '@components/utilities/BlanketInsurance/BlanketInsuranceCreateDetails';

export const AddBlanketInsurance: React.FC = () => <BlanketInsuranceCreateDetails type="create" />;
